export default "__VITE_ASSET__hMISamso4H$qjY4m5sO5Fw__"